<template>
  <v-card elevation="6" class="grey darken-1 mx-auto">
    <v-img :lazy-src="`https://odrive.h-disk.net/images/skin-${sid}.webp`">
      <v-card-title class="white--text">
        <v-chip v-if="private" color="warning" label>私有</v-chip>
        <v-chip v-else color="success" label>公开</v-chip>
        <span style="margin-left:10px">{{sname}}</span>
      </v-card-title>
      <v-card-text class="skinBox">
        <v-img :src="`https://odrive.h-disk.net/images/skin-${sid}.webp`">
          <template v-slot:placeholder>
            <v-row style="height:250px" align="center" justify="center">
              <v-progress-circular indeterminate color="black"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-card-text>
      <v-card-actions>
        <v-chip small color="primary">UP: {{up}}</v-chip>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('menu_click', 'usc#preview_skin@'+sid)"><v-icon>remove_red_eye</v-icon></v-btn>
        <v-menu offset-x>
          <template v-slot:activator="{ on }">
            <v-btn icon dark>
              <v-icon v-on="on">settings</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-if="private" @click="$emit('menu_click', 'usc#public')">
              <v-list-item-icon style="margin-right: 8px;">
                <v-icon>playlist_add</v-icon>
              </v-list-item-icon>
              <v-list-item-title>公开此皮肤</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-for="(menu, index) in menus"
              :key="`_SKINPAGE-USCMENU-${index}`"
              @click="$emit('menu_click', 'usc#'+menu.active)"
            >
              <v-list-item-icon style="margin-right: 8px;">
                <v-icon v-text="menu.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-actions>
    </v-img>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        {
          title: "重命名皮肤",
          icon: "create",
          active: "rename"
        },
        {
          title: "应用此皮肤",
          icon: "games",
          active: "to_game"
        },
        {
          title: "下载此皮肤",
          icon: "cloud_download",
          active: "download"
        },
        {
          title: "移除此皮肤",
          icon: "delete",
          active: "delete"
        }
      ]
    };
  },
  props: {
    private: {
      type: Boolean,
      default: false
    }, //is private
    sname: String, //Skin name.
    sid: Number, //Skin id
    up: String
  }
};
</script>

<style>
.skinBox {
  background: #fff
    url('data:image/svg+xml,\ <svg xmlns="http://www.w3.org/2000/svg" \ width="100" height="100" fill-opacity=".3">\ <rect x="50" width="50" height="50" /> \ <rect y="50" width="50" height="50" /> \ </svg>');
  background-size: 10% 10%;
}
</style>